// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__q9UGC","user":"FAQ_user__7EXSx","list":"FAQ_list__J3Ja0","card":"FAQ_card__E6biP","answer":"FAQ_answer__toiT2"};